import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { BorderRadius, Colors, FontSizeInPx, LineHeightInPx, Spacing } from "@snapchat/snap-design-system";
import { AddIcon, ReplayIcon } from "@snapchat/snap-design-system-icons";

export const SelectLensFolderPageContainer = styled.div`
    margin-top: 21px;
    padding: ${Spacing.MD}px ${Spacing.LG}px ${Spacing.LG}px ${Spacing.LG}px;
    background: ${Colors.WHITE};
    border-radius: ${BorderRadius.container}px;
`;

export const LensInformationTextContainer = styled.div`
    margin-bottom: ${Spacing["2XS"]}px;
    font-size: ${FontSizeInPx.COMPACT}px;
    line-height: ${LineHeightInPx.REGULAR}px;
    color: ${Colors.Black.V50};
`;

export const lensInformationContainer = css`
    margin-bottom: ${Spacing.MD}px;
`;

export const ButtonAddIcon = styled(AddIcon)`
    margin-right: 5px;
    vertical-align: text-top;
`;

export const ButtonReplayIcon = styled(ReplayIcon)`
    margin-right: 5px;
    vertical-align: text-top;
`;

export const updateAnExistingLensButton = css`
    margin-right: ${Spacing.MD}px;
`;

export const lensSubmissionDisclaimer = css`
    width: 500px;
`;
